import React, { useEffect, useRef, useState } from 'react'
import { Button, Card, DatePicker, message, Radio, Select, Spin, Upload } from 'antd'
import { SBack, SFormUploadImage, SGeneralForms, SMessage, SSteps } from 'shj-components'
import dayjs from 'dayjs'
import { useNavigate, useParams } from 'react-router-dom'
import { baseURL } from '@/api'
import { get, isArray } from 'lodash-es'
import { getVendorInfo, vendorInfoAdd, vendorInfoUpdateById } from '@/services/workerManagement'
import { getBanksAreasList, getBanksList, getBanksLocationsList, httpDictServ } from '@/services'
import { emailRegExp, idRegExp, phoneRegExp } from '@/utils/regular'
import { authenticationModal } from '@/pages/serviceConfig/workerManagement/component/authenticationModal'
import { getEnums, searchCompanyList } from '@/services/homeService'
import { useFileUrlPrefix } from 'shj-utils'
import { formatRelativeUploadData } from '@/utils/file'
import ImageUpload from '@/components/Upload/ImageUpload'

const { Option } = Select
const { RangePicker } = DatePicker
export const WorkerManagementAddOrEdit: React.FC<any> = _props => {
  const { id } = useParams()
  console.log(id)
  const formRef = useRef<any>()
  const fileUrlPrefix = useFileUrlPrefix()
  const history = useNavigate()
  const [typeKey, setTypeKey] = useState<string>('enterprise')
  const [bankNameList, setBankNameList] = useState<any>([])
  const [banksLocationsList, setBanksLocationsList] = useState<any>([])
  const [banksAreasList, setBanksAreasList] = useState<any>([])
  const [companyList, setCompanyList] = useState<any>([])
  const [bankCode, setBankCode] = useState<any>('')
  const [areaCode, setAreaCode] = useState<any>('')
  const [bankItem, setBankItem] = useState<any>(false)
  const [info, setInfo] = useState<any>(null)
  const [spinning, setSpinning] = useState<any>(false)
  const uploadFileUrl = baseURL + `/file-web/file/upload`
  const httpOptionsFn = (): Promise<Record<string, any>> => {
    return new Promise(async resolve => {
      const billingTypeEnum = await getEnums(
        'plus-pm',
        'com.shj.saas.plus.pm.domain.vendor.enums.BillingTypeEnum'
      )
      const verndorTypeEnum: any = await getEnums(
        'plus-pm',
        'com.shj.saas.plus.pm.domain.vendor.enums.VerndorTypeEnum'
      )
      const taxRateList = await getTaxRateList()
      const bankNameList = await getBanksList({ name: '' })
      const banksAreasList = await getBanksAreasList({ name: '' })
      const banksLocationsList = await getBanksLocationsList({ name: '' })
      const companyList = await searchCompanyList({ status: true })
      const distributionTypeEnum = await getEnums(
        'plus-pm',
        'com.shj.saas.plus.pm.domain.vendor.enums.DistributionTypeEnum'
      )
      const signatureModeEnum = await getEnums(
        'plus-pm',
        'com.shj.saas.plus.pm.domain.vendor.enums.SignatureModeEnum'
      )
      setBankNameList(bankNameList)
      setBanksAreasList(banksAreasList)
      setBanksLocationsList(banksLocationsList)
      setCompanyList(companyList)
      if (!id) {
        formRef.current?.onFormRef()?.setFieldsValue({ billingType: 'plainInvoice' })
      }
      resolve({
        typeCode: [
          { label: verndorTypeEnum[1].name, value: verndorTypeEnum[1].key },
          { label: verndorTypeEnum[0].name, value: verndorTypeEnum[0].key },
        ],
        billingTypeEnum,
        taxRateList,
        distributionTypeEnum,
        signatureModeEnum,
      })
    })
  }
  useEffect(() => {
    initFn()
  }, [])
  const disabledDate: any['disabledDate'] = (current, { from }) => {
    if (from) {
      return current && current < dayjs().subtract(1, 'day').endOf('day')
    }
  }
  // 处理数据
  const dealData = obj => {
    const newObj = { ...obj }
    if (isArray(newObj?.vendorOrgList) && newObj?.vendorOrgList.length > 0) {
      for (let m of newObj?.vendorOrgList) {
        if (m?.startDate) {
          m.cycleTime = [dayjs(m?.startDate), dayjs(m?.endDate)]
        }
      }
    } else {
      newObj.vendorOrgList = []
    }
    return newObj
  }
  const initFn = () => {
    if (id) {
      setSpinning(true)
      getVendorInfo({ id, labelFlag: true }).then(res => {
        res = dealData(res)
        setTypeKey(res.typeCode)
        res.fileInfolist = res.fileInfolist.map(item => {
          return {
            name: item,
            url: fileUrlPrefix + item,
            filePath: item,
          }
        })
        if (res?.vendorAccountInfo) {
          setBankItem(true)
          let accountImgBackUrl = [
            {
              name: res.vendorAccountInfo.accountImgBackUrl,
              url: fileUrlPrefix + res.vendorAccountInfo.accountImgBackUrl,
              filePath: res.vendorAccountInfo.accountImgBackUrl,
            },
          ]
          let accountImgFrontUrl = [
            {
              name: res.vendorAccountInfo.accountImgFrontUrl,
              url: fileUrlPrefix + res.vendorAccountInfo.accountImgFrontUrl,
              filePath: res.vendorAccountInfo.accountImgFrontUrl,
            },
          ]
          formRef.current?.onFormRef()?.setFieldsValue({
            ...res?.vendorAccountInfo,
            ...res,
            accountImgBackUrl,
            accountImgFrontUrl,
          })
        } else {
          formRef.current?.onFormRef()?.setFieldsValue({ ...res })
        }
        let infoData = { ...formRef.current?.onFormRef()?.getFieldsValue() }
        setInfo(infoData)
        setSpinning(false)
      })
    } else {
      formRef.current?.onFormRef()?.setFieldsValue({ typeCode: 'enterprise', vendorOrgList: [{}] })
    }
  }
  const getTaxRateList = () => {
    return httpDictServ({ parentKey: 'taxRate', enable: 1 }).then((response: any) => {
      return response
    })
  }
  const onSearchbankName = (value: string) => {
    getBanksList({ name: value }).then((response: any) => {
      setBankNameList(response)
    })
  }
  const onSearchBanksAreas = (value: string) => {
    getBanksAreasList({ name: value }).then((response: any) => {
      setBanksAreasList(response)
    })
  }
  const onSearchBanksLocations = (value: string, areaCode?: any) => {
    getBanksLocationsList({ areaCode, bankCode, branchNameKeyword: value }).then(
      (response: any) => {
        setBanksLocationsList(response)
      }
    )
  }
  const onSelectbankName = (_value, data) => {
    setBankCode(data?.key)
    setBanksLocationsList([])
  }
  const onSelectBanksAreas = (_value, data) => {
    setAreaCode(data?.key)
    onSearchBanksLocations('', data?.key)
  }
  const onSelectBankBranchName = (_value, data) => {
    const values = formRef.current?.onFormRef()?.getFieldsValue()
    values.bankBranchNumber = data?.dataId
    values.bankBranchCode = data?.key
    formRef.current?.onFormRef()?.setFieldsValue({ ...values })
  }
  const changeType = v => {
    setTypeKey(v.target.value)
  }

  // 去认证
  const goAuthenticationFn = info => {
    let dialog = SMessage.confirm({
      title: false,
      icon: null,
      content: (
        <SSteps
          current={1}
          items={[
            {
              title: '新增/修改',
            },
            {
              title: '完成认证',
            },
          ]}
        />
      ),
      okText: '去认证',
      onOk: () => {
        dialog?.destroy()
        authenticationModal({
          title: info?.typeCode === 'personal' ? '个人认证' : '商家认证',
          info,
          onclose: () => {
            history('/config/serviceConfig/workerManagement')
          },
          detailsData: info,
          isView: false,
        })
      },
      onCancel: () => {
        history(-1)
        dialog?.destroy()
      },
    })
  }
  const onFinish = value => {
    let fileInfolist: any = []
    value?.fileInfolist &&
      value?.fileInfolist.map((item: any) => {
        fileInfolist.push(item?.filePath || item.response.data?.filePath)
      })
    value.fileInfolist = fileInfolist
    if (value.vendorOrgList && value.vendorOrgList.length) {
      for (let m of value.vendorOrgList) {
        if (m.cycleTime) {
          m.startDate = dayjs(m.cycleTime[0]).valueOf()
          m.endDate = dayjs(m.cycleTime[1]).valueOf()
        }
        for (let n of companyList) {
          if (n.orgId === m.orgId) {
            m.companyName = n.companyName
          }
        }
        delete m.id
        delete m.cycleTime
      }
    }
    if (value.bankName) {
      const vendorAccountInfo = {
        bankName: value.bankName,
        bankCode: bankCode,
        cityName: value.cityName,
        cityCode: areaCode,
        bankBranchName: value.bankBranchName,
        bankBranchNumber: value.bankBranchNumber,
        bankBranchCode: value.bankBranchCode,
        bankAddress: value.bankAddress,
        accountCode: value.accountCode,
        mainFlag: true,
        accountImgFrontUrl: value?.accountImgFrontUrl[0]?.filePath,
        accountImgBackUrl: value?.accountImgBackUrl[0]?.filePath,
      }
      value.vendorAccountInfo = vendorAccountInfo
    }
    setSpinning(true)
    if (id) {
      vendorInfoUpdateById(value)
        .then(res => {
          setSpinning(false)
          if (res.status) {
            history('/config/serviceConfig/workerManagement')
          } else {
            goAuthenticationFn(res)
          }
        })
        .finally(() => {
          setSpinning(false)
        })
    } else {
      vendorInfoAdd(value)
        .then(res => {
          setSpinning(false)
          goAuthenticationFn(res)
        })
        .finally(() => {
          setSpinning(false)
        })
    }
  }

  const onAddBank = () => {
    if (bankItem) {
      setBankItem(false)
    } else {
      setBankItem(true)
    }
  }
  const beforeUpload = (file: any) => {
    if ((file.type || '').startsWith('image')) {
      if (
        !file.name.endsWith('.jpg') &&
        !file.name.endsWith('.bmp') &&
        !file.name.endsWith('.png') &&
        !file.name.endsWith('.jpeg')
      ) {
        message.error('图片必须是jpg/jpeg/png/bmp格式')
        return Upload.LIST_IGNORE
      }
      return true
    }
    message.error('只能上传图片')
    return Upload.LIST_IGNORE
  }
  const isShowDelIconFn = (index, _item) => {
    return info?.vendorOrgList.length !== 1
  }
  return (
    <Spin spinning={spinning}>
      <SBack title={id ? '编辑' + info?.name : '承包商新增'} level={2}>
        <Card bordered={false} style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
          <SGeneralForms
            isFooterBtn={true}
            footerAlign="right"
            httpOptionsFn={httpOptionsFn}
            ref={formRef}
            onFinish={onFinish}
            isHideResetBtn={true}
            isHideGobackBtn={true}
            layout={'vertical'}
            onRemove={value => {
              const index_ = value?.key
              let vendorOrgList = formRef.current?.onFormRef()?.getFieldValue('vendorOrgList')
              if (vendorOrgList[index_]?.id) {
                message.error('数据被关联无法删除')
              } else {
                value?.remove(value?.name)
              }
            }}
            configs={[
              {
                title: '承包商',
                titleMode: 'drawer',
                formItem: [
                  { label: 'id', name: 'id', hidden: true },
                  { label: 'status', name: 'status', hidden: true },
                  { label: 'caasEmployeeId', name: 'caasEmployeeId', hidden: true },
                  {
                    name: 'typeCode',
                    label: '类型',
                    spanCol: 24,
                    type: 'radio',
                    required: true,
                    children: (
                      <Radio.Group onChange={changeType} disabled={id ? true : false}>
                        <Radio value={'enterprise'}>商家</Radio>
                        <Radio value={'personal'}>个人</Radio>
                      </Radio.Group>
                    ),
                    data: 'typeCode',
                  },
                  {
                    name: 'vendorCode',
                    label: '账号',
                    spanCol: 8,
                    isHideItem: id ? false : true,
                    comConfig: {
                      disabled: true,
                    },
                  },
                  {
                    name: 'name',
                    label: '承包商名称',
                    spanCol: 8,
                    maxLength: 30,
                    required: true,
                  },
                  {
                    name: 'businessLicence',
                    label: '信用代码',
                    maxLength: 30,
                    spanCol: 8,
                    required: true,
                    isHideItem: typeKey === 'enterprise' ? false : true,
                    comConfig: {
                      disabled: id ? true : false,
                      placeholder: '请输入营业执照',
                    },
                  },
                  {
                    name: 'emails',
                    label: '邮箱',
                    spanCol: 8,
                    maxLength: 30,
                    required: true,
                    rules: [
                      { required: true, message: '请输入邮箱' },
                      { required: false, message: '请输入正确的邮箱', pattern: emailRegExp },
                    ],
                    comConfig: {
                      placeholder: '请输入企业邮箱',
                    },
                  },
                  {
                    name: 'corporateName',
                    label: '法人姓名',
                    spanCol: 8,
                    maxLength: 20,
                    required: true,
                  },
                  {
                    name: 'corporateCode',
                    label: '法人证件号',
                    required: true,
                    maxLength: 20,
                    spanCol: 8,
                    rules: [{ required: true, message: '请输入法人证件号', pattern: idRegExp }],
                  },
                  {
                    name: 'phone',
                    label: '法人电话',
                    required: true,
                    spanCol: 8,
                    maxLength: 11,
                    rules: [{ required: true, message: '请输入法人电话', pattern: phoneRegExp }],
                  },
                  {
                    name: 'managerName',
                    label: '负责人姓名',
                    required: true,
                    maxLength: 20,
                    spanCol: 8,
                  },
                  {
                    name: 'managerPhone',
                    label: '负责人电话',
                    required: true,
                    spanCol: 8,
                    maxLength: 11,
                    rules: [{ required: true, message: '请输入负责人电话', pattern: phoneRegExp }],
                  },
                  {
                    name: 'billingType',
                    label: '开票类型',
                    type: 'select',
                    data: 'billingTypeEnum',
                    comConfig: {
                      fieldNames: {
                        label: 'description',
                        value: 'key',
                      },
                    },
                    required: true,
                    spanCol: 8,
                  },
                  {
                    name: 'taxRate',
                    label: '税率',
                    type: 'select',
                    data: 'taxRateList',
                    comConfig: {
                      fieldNames: {
                        label: 'name',
                        value: 'key',
                      },
                    },
                    required: true,
                    spanCol: 8,
                  },
                  {
                    name: 'statusName',
                    label: '认证状态',
                    spanCol: 8,
                    isHideItem: id ? false : true,
                    comConfig: {
                      disabled: true,
                    },
                  },
                  { name: 'address', label: '地址', required: true, maxLength: 50, spanCol: 8 },
                  {
                    name: 'remarks',
                    label: '备注',
                    spanCol: 24,
                    type: 'textarea',
                    maxLength: 100,
                    comConfig: {
                      maxLength: 100,
                      rows: 4,
                      placeholder: '请输入备注',
                    },
                  },
                  {
                    name: 'fileInfolist',
                    label: '附件(1-3张图)',
                    spanCol: 24,
                    required: true,
                    children: (
                      <ImageUpload 
                      limit={3}
                      maxCount={3} 
                      multiple={true}
                      url={uploadFileUrl}
                      accept={'.jpg,.jpeg,.png,.bmp'}
                      beforeUpload={beforeUpload} />
                    ),
                  },
                ],
              },
              {
                title: '开户信息',
                titleMode: 'drawer',
                customBtn: [
                  <Button type="primary" onClick={onAddBank}>
                    {bankItem ? '删除开户信息' : '添加开户信息'}
                  </Button>,
                ],
                formItem: bankItem
                  ? [
                      {
                        name: 'bankName',
                        label: '银行名称',
                        type: 'select',
                        data: 'bankNameList',
                        required: true,
                        spanCol: 8,
                        children: (
                          <Select
                            showSearch={true}
                            onSearch={onSearchbankName}
                            onSelect={onSelectbankName}
                            placeholder={'请选择银行名称'}
                          >
                            {bankNameList.map((item: any) => (
                              <Option key={item.bankCode} value={item.bankName}>
                                {item.bankName}
                              </Option>
                            ))}
                          </Select>
                        ),
                      },
                      {
                        name: 'cityName',
                        label: '所在城市',
                        type: 'select',
                        data: 'banksAreasList',
                        required: true,
                        spanCol: 8,
                        children: (
                          <Select
                            showSearch={true}
                            onSearch={onSearchBanksAreas}
                            onSelect={onSelectBanksAreas}
                            placeholder={'请选择所在城市'}
                          >
                            {banksAreasList.map((item: any) => (
                              <Option key={item.areaCode} value={item.areaName}>
                                {item.areaName}
                              </Option>
                            ))}
                          </Select>
                        ),
                      },
                      {
                        name: 'bankBranchName',
                        label: '支行名称',
                        type: 'select',
                        data: 'banksLocationsList',
                        required: true,
                        spanCol: 8,
                        children: (
                          <Select
                            showSearch={true}
                            onSearch={onSearchBanksLocations}
                            onSelect={onSelectBankBranchName}
                            placeholder={'请选择支行名称'}
                          >
                            {banksLocationsList.map((item: any) => (
                              <Option
                                key={item.branchCode}
                                value={item.branchName}
                                dataId={item.id}
                              >
                                {item.branchName}
                              </Option>
                            ))}
                          </Select>
                        ),
                      },
                      {
                        name: 'bankBranchNumber',
                        label: '银行网点联行号',
                        spanCol: 8,
                        comConfig: {
                          disabled: true,
                        },
                      },
                      {
                        name: 'accountCode',
                        label: '账号',
                        maxLength: 50,
                        required: true,
                        spanCol: 8,
                        rules: [
                          { required: true, message: '请输入账号' },
                          { required: false, message: '请输入数字，最大长度为50位' },
                        ],
                      },
                      {
                        name: 'name',
                        label: '账号名称',
                        spanCol: 8,
                        comConfig: {
                          disabled: true,
                        },
                      },
                      {
                        name: 'bankAddress',
                        label: '地址',
                        maxLength: 50,
                        required: true,
                        spanCol: 8,
                      },
                      {
                        name: 'accountImgFrontUrl',
                        label: '银行卡正面',
                        spanCol: 8,
                        required: true,
                        children: (
                          <SFormUploadImage
                            accept={'.jpg,.jpeg,.png,.bmp'}
                            beforeUpload={beforeUpload}
                            limit={1}
                            url={uploadFileUrl}
                            setFileUrl={formatRelativeUploadData}
                          />
                        ),
                      },
                      {
                        name: 'accountImgBackUrl',
                        label: '银行卡背面',
                        spanCol: 8,
                        htmlFor: 'accountImgBackUrl',
                        required: true,
                        children: (
                          <SFormUploadImage
                            accept={'.jpg,.jpeg,.png,.bmp'}
                            beforeUpload={beforeUpload}
                            maxCount={1}
                            limit={1}
                            url={uploadFileUrl}
                            setFileUrl={formatRelativeUploadData}
                          />
                        ),
                      },
                      { name: 'bankBranchCode', hidden: true },
                      { name: 'bankBranchNumber', hidden: true },
                    ]
                  : [],
              },
              {
                title: '合作信息',
                titleMode: 'drawer',
                type: 'multiple',
                formName: 'vendorOrgList',
                isShowDelIconFn: isShowDelIconFn,
                formItem: [
                  {
                    label: '门店',
                    name: 'companyId',
                    required: true,
                    spanCol: 8,
                    children: (_formRef?: any, _formItem?: any, index?: any) => {
                      return info?.vendorOrgList[index] ? (
                        <span>：{info?.vendorOrgList[index]?.companyName}</span>
                      ) : (
                        <Select
                          showSearch={true}
                          placeholder={'请选择门店'}
                          filterOption={(input, option: any) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {companyList.map((item: any) => (
                            <Option key={item.orgId} value={item.orgId}>
                              {item.companyName}
                            </Option>
                          ))}
                        </Select>
                      )
                    },
                  },
                  {
                    label: '分配模式',
                    name: 'allocationModes',
                    required: true,
                    type: 'select',
                    data: 'distributionTypeEnum',
                    comConfig: {
                      mode: 'multiple',
                      fieldNames: {
                        label: 'description',
                        value: 'key',
                      },
                    },
                    spanCol: 8,
                  },
                  {
                    label: '合作周期',
                    name: 'cycleTime',
                    required: true,
                    spanCol: 8,
                    children: (_formRef?: any, _formItem?: any, index?: any) => {
                      return (
                        <RangePicker
                          disabledDate={disabledDate}
                          disabled={[info?.vendorOrgList[index], false]}
                        />
                      )
                    },
                  },
                  {
                    label: '签章方式',
                    tooltip: '开启电子签有效',
                    required: true,
                    name: 'signatureMode',
                    type: 'select',
                    comConfig: {
                      fieldNames: {
                        label: 'description',
                        value: 'key',
                      },
                    },
                    data: 'signatureModeEnum',
                    spanCol: 8,
                  },
                ],
              },
            ]}
          />
        </Card>
      </SBack>
    </Spin>
  )
}

export default WorkerManagementAddOrEdit
